const NQ_T={
  en:{
    eyebrow:'Find your match',
    title:'What suits your skin?',
    sub:'Answer a few questions and receive your personal product recommendation.',
    next:'Next \u2192',
    back:'\u2190 Back',
    viewResult:'View your recommendation \u2192',
    retake:'Retake quiz',
    viewProduct:'View product \u2192',
    recommendation:'Your recommendation',
    secondPick:'Also a great match',
    altLabel:'You might also like',
    routineBtn:'Complete your routine',
    routineClose:'Close routine',
    stepOf:function(n,tot){return 'Step '+n+' of '+tot;},
    s0q:'What are you looking for?',
    s1q:'What is your skin type?',
    s2q_body:'How do you want your skin to feel after moisturising?',
    s2q_shower:'Where do you want to use this product?',
    s2q_face:'What type of product are you looking for?',
    s3q_shower_body:'What type of shower product are you looking for?',
    s3q_body:'Which scent appeals to you?',
    s3q_creme:'How would you describe your skin?',
    s3q_sensitive:'Which scent appeals to you?',
    s4q_shower:'Which scent appeals to you?',
    cats:[
      {val:'body',   title:'Body care',         sub:'Body butter, lotion, oil'},
      {val:'shower', title:'Shower & cleansing', sub:'Shower oil, black soap wash'},
      {val:'face',   title:'Face care',          sub:'Face cream, argan oil'}
    ],
    skins:[
      {val:'dry',       title:'Dry',                 sub:'My skin often feels tight and sometimes flakes'},
      {val:'normal',    title:'Normal / combination', sub:'Not too dry, not too oily'},
      {val:'sensitive', title:'Sensitive',            sub:'Reacts quickly to scents or ingredients'}
    ],
    textures_body:[
      {val:'rich',  title:'Deeply nourishing',           sub:'I want to deeply nourish my skin, even if it takes a moment to absorb',        hint:'This is a body butter'},
      {val:'light', title:'Light & non-sticky',          sub:'I want something that absorbs quickly and does not feel sticky, with less oil', hint:'This is a body lotion'},
      {val:'oil',   title:'Radiant glow, no residue',    sub:'I want a light glow that absorbs quickly and leaves nothing behind',           hint:'This is a body oil'}
    ],
    shower_target:[
      {val:'face', title:'My face', sub:'Cleansing my face in the shower'},
      {val:'body', title:'My body', sub:'Nourishing or cleansing my body'}
    ],
    textures_shower:[
      {val:'oilshower', title:'Nourishing & pampering', sub:'I want my skin to already feel cared for while I am in the shower'},
      {val:'clean',     title:'Thoroughly cleansing',   sub:'I want to feel thoroughly clean and fresh after showering'}
    ],
    face_types:[
      {val:'creme',   title:'A cream',    sub:'Hydrate and protect my skin with a nourishing cream'},
      {val:'oilface', title:'A face oil', sub:'A light oil that absorbs fast and works precisely'}
    ],
    scents_body:[
      {val:'fruity',  title:'Tropical & summery',     sub:'Fresh, fruity, summer vibes'},
      {val:'sweet',   title:'Sweet & playful',         sub:'Warm, sweet and intense'},
      {val:'neutral', title:'No preference / neutral', sub:'Preferably without a strong scent'}
    ],
    scents_body_no_neutral:[
      {val:'fruity', title:'Tropical & summery', sub:'Fresh, fruity, summer vibes'},
      {val:'sweet',  title:'Sweet & playful',    sub:'Warm, sweet and intense'}
    ],
    scents_shower:[
      {val:'fruity', title:'Tropical & summery', sub:'Fresh, fruity, summer vibes'},
      {val:'sweet',  title:'Sweet & playful',    sub:'Warm, sweet and intense'}
    ],
    scents_sensitive:[
      {val:'kokos', title:'Natural coconut butter', sub:'Light, fresh and nourishing'},
      {val:'cacao', title:'Natural cacao butter',   sub:'Rich, warm and slightly thicker texture'}
    ],
    creme_skins:[
      {val:'mature',    title:'Mature skin',    sub:'My skin needs extra nourishment and anti-aging care'},
      {val:'sensitive', title:'Sensitive skin', sub:'My skin reacts quickly and needs mild ingredients'}
    ]
  },
  nl:{
    eyebrow:'Vind jouw match',
    title:'Wat past bij jouw huid?',
    sub:'Beantwoord een paar vragen en ontvang jouw persoonlijke match.',
    next:'Volgende \u2192',
    back:'\u2190 Terug',
    viewResult:'Bekijk jouw match \u2192',
    retake:'Quiz opnieuw doen',
    viewProduct:'Bekijk product \u2192',
    recommendation:'Jouw persoonlijke advies',
    secondPick:'Ook een goede match',
    altLabel:'Misschien ook leuk',
    routineBtn:'Maak je routine compleet',
    routineClose:'Routine verbergen',
    stepOf:function(n,tot){return 'Stap '+n+' van '+tot;},
    s0q:'Waar ben je naar op zoek?',
    s1q:'Wat is jouw huidtype?',
    s2q_body:'Hoe wil jij dat je huid aanvoelt na het insmeren?',
    s2q_shower:'Waar wil je dit product voor gebruiken?',
    s2q_face:'Welk type product zoek je?',
    s3q_shower_body:'Wat voor type doucheproduct zoek je?',
    s3q_body:'Welke geur spreekt jou aan?',
    s3q_creme:'Hoe zou je jouw huid omschrijven?',
    s3q_sensitive:'Welke geur spreekt jou aan?',
    s4q_shower:'Welke geur spreekt jou aan?',
    cats:[
      {val:'body',   title:'Lichaamsverzorging', sub:'Body butter, lotion, olie'},
      {val:'shower', title:'Douche & reiniging',  sub:'Shower oil, black soap wash'},
      {val:'face',   title:'Gezichtsverzorging',  sub:'Gezichtscrème, arganolie'}
    ],
    skins:[
      {val:'dry',       title:'Droog',            sub:'Mijn huid voelt vaak strak aan en schilfert soms'},
      {val:'normal',    title:'Normaal / gemengd', sub:'Niet te droog, niet te vet'},
      {val:'sensitive', title:'Gevoelig',          sub:'Reageert snel op geuren of ingrediënten'}
    ],
    textures_body:[
      {val:'rich',  title:'Intensief voedend',            sub:'Ik wil mijn huid intensief verzorgen, ook als het even duurt voor het intrekt',  hint:'Dit is een body butter'},
      {val:'light', title:'Licht & niet-plakkend',        sub:'Ik wil iets wat snel intrekt en niet plakt, met minder olie',                    hint:'Dit is een body lotion'},
      {val:'oil',   title:'Stralende glow, geen restlaagje', sub:'Ik wil een lichte glow die snel intrekt en niks achterlaat',                 hint:'Dit is een body oil'}
    ],
    shower_target:[
      {val:'face', title:'Mijn gezicht', sub:'Mijn gezicht reinigen onder de douche'},
      {val:'body', title:'Mijn lichaam', sub:'Mijn lichaam verzorgen of reinigen'}
    ],
    textures_shower:[
      {val:'oilshower', title:'Voedend & verzorgend', sub:'Ik wil dat mijn huid zich al verzorgd voelt terwijl ik onder de douche sta'},
      {val:'clean',     title:'Grondig reinigend',    sub:'Ik wil me na het douchen echt schoon en fris voelen'}
    ],
    face_types:[
      {val:'creme',   title:'Een crème',       sub:'Mijn huid hydrateren en beschermen met een voedende crème'},
      {val:'oilface', title:'Een gezichtsolie', sub:'Een lichte olie die snel intrekt en gericht werkt'}
    ],
    scents_body:[
      {val:'fruity',  title:'Tropisch & zomers',       sub:'Fris, fruitig, zomerse vibes'},
      {val:'sweet',   title:'Zoet & speels',            sub:'Warm, zoet en intens'},
      {val:'neutral', title:'Geen voorkeur / neutraal', sub:'Het liefst zonder sterke geur'}
    ],
    scents_body_no_neutral:[
      {val:'fruity', title:'Tropisch & zomers', sub:'Fris, fruitig, zomerse vibes'},
      {val:'sweet',  title:'Zoet & speels',     sub:'Warm, zoet en intens'}
    ],
    scents_shower:[
      {val:'fruity', title:'Tropisch & zomers', sub:'Fris, fruitig, zomerse vibes'},
      {val:'sweet',  title:'Zoet & speels',     sub:'Warm, zoet en intens'}
    ],
    scents_sensitive:[
      {val:'kokos', title:'Natuurlijke kokosolie',  sub:'Licht, fris en voedend'},
      {val:'cacao', title:'Natuurlijke cacaoboter', sub:'Rijk, warm en wat dikker van structuur'}
    ],
    creme_skins:[
      {val:'mature',    title:'Rijpere huid',   sub:'Mijn huid heeft extra voeding en anti-aging verzorging nodig'},
      {val:'sensitive', title:'Gevoelige huid', sub:'Mijn huid reageert snel en heeft zachte ingrediënten nodig'}
    ]
  },
  de:{
    eyebrow:'Finde dein Match',
    title:'Was passt zu deiner Haut?',
    sub:'Beantworte ein paar Fragen und erhalte deine persönliche Empfehlung.',
    next:'Weiter \u2192',
    back:'\u2190 Zurück',
    viewResult:'Sieh dir deine Empfehlung an \u2192',
    retake:'Quiz wiederholen',
    viewProduct:'Produkt ansehen \u2192',
    recommendation:'Dein persönlicher Tipp',
    secondPick:'Auch eine tolle Wahl',
    altLabel:'Das könnte dir auch gefallen',
    routineBtn:'Vervollständige deine Routine',
    routineClose:'Routine ausblenden',
    stepOf:function(n,tot){return 'Schritt '+n+' von '+tot;},
    s0q:'Was suchst du?',
    s1q:'Was ist dein Hauttyp?',
    s2q_body:'Wie soll sich deine Haut nach dem Eincremen anfühlen?',
    s2q_shower:'Wofür möchtest du dieses Produkt verwenden?',
    s2q_face:'Welches Produkt suchst du?',
    s3q_shower_body:'Was für ein Duschprodukt suchst du?',
    s3q_body:'Welcher Duft gefällt dir?',
    s3q_creme:'Wie würdest du deine Haut beschreiben?',
    s3q_sensitive:'Welcher Duft gefällt dir?',
    s4q_shower:'Welcher Duft gefällt dir?',
    cats:[
      {val:'body',   title:'Körperpflege',       sub:'Body Butter, Lotion, Öl'},
      {val:'shower', title:'Duschen & Reinigung', sub:'Duschöl, Black Soap Wash'},
      {val:'face',   title:'Gesichtspflege',      sub:'Gesichtscreme, Arganöl'}
    ],
    skins:[
      {val:'dry',       title:'Trocken',          sub:'Meine Haut fühlt sich oft gespannt an und schuppt manchmal'},
      {val:'normal',    title:'Normal / gemischt', sub:'Nicht zu trocken, nicht zu fettig'},
      {val:'sensitive', title:'Empfindlich',       sub:'Reagiert schnell auf Düfte oder Inhaltsstoffe'}
    ],
    textures_body:[
      {val:'rich',  title:'Intensiv pflegend',                sub:'Ich möchte meine Haut intensiv pflegen, auch wenn es etwas länger braucht zum Einziehen', hint:'Das ist eine Body Butter'},
      {val:'light', title:'Leicht & nicht klebrig',           sub:'Ich möchte etwas, das schnell einzieht und nicht klebt, mit weniger Öl',                  hint:'Das ist eine Body Lotion'},
      {val:'oil',   title:'Strahlender Glow, kein Rückstand', sub:'Ich möchte einen leichten Glow, der schnell einzieht und nichts hinterlässt',             hint:'Das ist ein Body Öl'}
    ],
    shower_target:[
      {val:'face', title:'Mein Gesicht',  sub:'Mein Gesicht unter der Dusche reinigen'},
      {val:'body', title:'Meinen Körper', sub:'Meinen Körper pflegen oder reinigen'}
    ],
    textures_shower:[
      {val:'oilshower', title:'Pflegend & verwöhnend', sub:'Ich möchte, dass sich meine Haut schon unter der Dusche gepflegt anfühlt'},
      {val:'clean',     title:'Gründlich reinigend',   sub:'Ich möchte mich nach dem Duschen richtig sauber und frisch fühlen'}
    ],
    face_types:[
      {val:'creme',   title:'Eine Creme',     sub:'Meine Haut mit einer pflegenden Creme hydratisieren und schützen'},
      {val:'oilface', title:'Ein Gesichtsöl', sub:'Ein leichtes Öl, das schnell einzieht und gezielt wirkt'}
    ],
    scents_body:[
      {val:'fruity',  title:'Tropisch & sommerlich',    sub:'Frisch, fruchtig, sommerliche Vibes'},
      {val:'sweet',   title:'Süß & verspielt',           sub:'Warm, süß und intensiv'},
      {val:'neutral', title:'Keine Präferenz / neutral', sub:'Am liebsten ohne starken Duft'}
    ],
    scents_body_no_neutral:[
      {val:'fruity', title:'Tropisch & sommerlich', sub:'Frisch, fruchtig, sommerliche Vibes'},
      {val:'sweet',  title:'Süß & verspielt',       sub:'Warm, süß und intensiv'}
    ],
    scents_shower:[
      {val:'fruity', title:'Tropisch & sommerlich', sub:'Frisch, fruchtig, sommerliche Vibes'},
      {val:'sweet',  title:'Süß & verspielt',       sub:'Warm, süß und intensiv'}
    ],
    scents_sensitive:[
      {val:'kokos', title:'Natürliche Kokosbutter', sub:'Leicht, frisch und pflegend'},
      {val:'cacao', title:'Natürliche Kakaobutter', sub:'Reich, warm und etwas dickere Textur'}
    ],
    creme_skins:[
      {val:'mature',    title:'Reifere Haut',      sub:'Meine Haut braucht extra Pflege und Anti-Aging Unterstützung'},
      {val:'sensitive', title:'Empfindliche Haut', sub:'Meine Haut reagiert schnell und braucht sanfte Inhaltsstoffe'}
    ]
  }
};

const NQ_URLS={
  en:{
    'Coco Paradise Body Butter':      '/products/body-butter-coco-paradise',
    'Cotton Candy Body Butter':       '/products/cotton-candy-2',
    'Plain Jane Body Butter':         '/products/body-butter-sensitive',
    'Classic Body Butter':            '/products/body-butter-vanille',
    'Coco-Loco Body Butter':          '/products/body-butter-coco-loco-1',
    'Lemon Pie Icecream Body Butter': '/products/body-butter-lemon-pie-icecream',
    'Coco Paradise Body Lotion':      '/products/body-lotion-coco-paradise',
    'Mangonuts Body Lotion':          '/products/mangonuts',
    'Aloha Body Lotion':              '/products/body-lotion-aloha',
    'Coco Paradise Body Oil':         '/products/body-oil-coco-paradise',
    'Aloha Body Oil':                 '/products/body-oil-aloha',
    'Coco Paradise Shower Oil':       '/products/shower-oil-coco-paradise',
    'Aloha Shower Oil':               '/products/shower-oil-aloha',
    'Black Soap Body Wash':           '/products/black-soap-body-wash',
    'Black Soap Face Wash':           '/products/black-soap-face-wash',
    'Forever 21 Face Cream':          '/products/forever-21-anti-age-creme',
    'Still 21 Face Cream':            '/products/still-21',
    'Drops of Nature Argan Oil':      '/products/drops-of-nature'
  },
  nl:{
    'Coco Paradise Body Butter':      '/nl/products/body-butter-coco-paradise',
    'Cotton Candy Body Butter':       '/nl/products/cotton-candy-2',
    'Plain Jane Body Butter':         '/nl/products/body-butter-sensitive',
    'Classic Body Butter':            '/nl/products/body-butter-vanille',
    'Coco-Loco Body Butter':          '/nl/products/body-butter-coco-loco-1',
    'Lemon Pie Icecream Body Butter': '/nl/products/body-butter-lemon-pie-icecream',
    'Coco Paradise Body Lotion':      '/nl/products/body-lotion-coco-paradise',
    'Mangonuts Body Lotion':          '/nl/products/mangonuts',
    'Aloha Body Lotion':              '/nl/products/body-lotion-aloha',
    'Coco Paradise Body Oil':         '/nl/products/body-oil-coco-paradise',
    'Aloha Body Oil':                 '/nl/products/body-oil-aloha',
    'Coco Paradise Shower Oil':       '/nl/products/shower-oil-coco-paradise',
    'Aloha Shower Oil':               '/nl/products/shower-oil-aloha',
    'Black Soap Body Wash':           '/nl/products/black-soap-body-wash',
    'Black Soap Face Wash':           '/nl/products/black-soap-face-wash',
    'Forever 21 Face Cream':          '/nl/products/forever-21-anti-age-creme',
    'Still 21 Face Cream':            '/nl/products/still-21',
    'Drops of Nature Argan Oil':      '/nl/products/drops-of-nature'
  },
  de:{
    'Coco Paradise Body Butter':      '/products/body-butter-coco-paradise',
    'Cotton Candy Body Butter':       '/products/cotton-candy-2',
    'Plain Jane Body Butter':         '/products/body-butter-sensitive',
    'Classic Body Butter':            '/products/body-butter-vanille',
    'Coco-Loco Body Butter':          '/products/body-butter-coco-loco-1',
    'Lemon Pie Icecream Body Butter': '/products/body-butter-lemon-pie-icecream',
    'Coco Paradise Body Lotion':      '/products/body-lotion-coco-paradise',
    'Mangonuts Body Lotion':          '/products/mangonuts',
    'Aloha Body Lotion':              '/products/body-lotion-aloha',
    'Coco Paradise Body Oil':         '/products/body-oil-coco-paradise',
    'Aloha Body Oil':                 '/products/body-oil-aloha',
    'Coco Paradise Shower Oil':       '/products/shower-oil-coco-paradise',
    'Aloha Shower Oil':               '/products/shower-oil-aloha',
    'Black Soap Body Wash':           '/products/black-soap-body-wash',
    'Black Soap Face Wash':           '/products/black-soap-face-wash',
    'Forever 21 Face Cream':          '/products/forever-21-anti-age-creme',
    'Still 21 Face Cream':            '/products/still-21',
    'Drops of Nature Argan Oil':      '/products/drops-of-nature'
  }
};

var NQ_LANG='en';
function nqUrl(n){return (NQ_URLS[NQ_LANG]||NQ_URLS.en)[n]||'/collections/all';}

function nqSetLang(lang,btn){
  NQ_LANG=lang;
  document.querySelectorAll('.nq-lang-btn').forEach(function(b){b.classList.remove('active');});
  btn.classList.add('active');
  nqRebuildUI();
}

function nqRebuildUI(){
  var t=NQ_T[NQ_LANG];
  document.getElementById('nq-eyebrow').textContent=t.eyebrow;
  document.getElementById('nq-title').textContent=t.title;
  document.getElementById('nq-sub').textContent=t.sub;
  document.getElementById('nq-btn-retake').textContent=t.retake;
  document.getElementById('nq-routine-btn-label').textContent=t.routineBtn;
  ['back-1','back-2','back-3','back-4'].forEach(function(id){var el=document.getElementById('nq-'+id);if(el)el.textContent=t.back;});
  ['next-0','next-1','next-2','next-3','next-4'].forEach(function(id){var el=document.getElementById('nq-'+id);if(el)el.textContent=t.next;});
  document.getElementById('nq-s0-q').textContent=t.s0q;
  nqBuildOpts('nq-s0-opts',t.cats,0,'cat');
  nqA={cat:null,skin:null,tex:null,target:null,shower:null,scent:null};
  nqStep=0;
  document.querySelectorAll('.nq-step').forEach(function(s){s.classList.remove('active');});
  document.querySelectorAll('.nq-opt').forEach(function(b){b.classList.remove('nq-selected');});
  document.querySelectorAll('.nq-btn-next').forEach(function(b){b.classList.remove('nq-enabled');});
  document.getElementById('nq-step-0').classList.add('active');
  nqUpdateStepLabel('nq-s0-label',1,4);
  nqUpdateProgress();
}

function nqGetResult(a){
  var cat=a.cat,skin=a.skin,tex=a.tex,target=a.target,shower=a.shower,scent=a.scent;

  if(cat==='face'){
    if(tex==='oilface')
      return{main:'Drops of Nature Argan Oil',second:null,alt:null,
             routine:[{name:'Still 21 Face Cream',tip:{en:'Hydrate your face afterwards',nl:'Hydrateer daarna je gezicht',de:'Feuchtigkeitspflege danach für dein Gesicht'}},
                      {name:'Black Soap Face Wash',tip:{en:'Cleanse your face in the shower',nl:'Reinig je gezicht onder de douche',de:'Reinige dein Gesicht unter der Dusche'}}]};
    if(tex==='creme'&&skin==='mature')
      return{main:'Forever 21 Face Cream',second:null,alt:'Still 21 Face Cream',
             routine:[{name:'Drops of Nature Argan Oil',tip:{en:'Apply as the last step after your cream',nl:'Breng aan als laatste stap na je crème',de:'Als letzten Schritt nach deiner Creme auftragen'}},
                      {name:'Black Soap Face Wash',tip:{en:'Cleanse your face in the shower',nl:'Reinig je gezicht onder de douche',de:'Reinige dein Gesicht unter der Dusche'}}]};
    if(tex==='creme')
      return{main:'Still 21 Face Cream',second:null,alt:null,
             routine:[{name:'Drops of Nature Argan Oil',tip:{en:'Apply as the last step after your cream',nl:'Breng aan als laatste stap na je crème',de:'Als letzten Schritt nach deiner Creme auftragen'}},
                      {name:'Black Soap Face Wash',tip:{en:'Cleanse your face in the shower',nl:'Reinig je gezicht onder de douche',de:'Reinige dein Gesicht unter der Dusche'}}]};
  }

  if(cat==='shower'){
    if(skin==='sensitive')
      return{main:'Black Soap Body Wash',second:null,alt:null,
             routine:[{name:'Black Soap Face Wash',tip:{en:'Cleanse your face too',nl:'Reinig ook je gezicht',de:'Reinige auch dein Gesicht'}},
                      {name:'Still 21 Face Cream',tip:{en:'Hydrate your face afterwards',nl:'Hydrateer daarna je gezicht',de:'Feuchtigkeitspflege danach für dein Gesicht'}},
                      {name:'Plain Jane Body Butter',tip:{en:'Nourish your body after showering',nl:'Verzorg je lichaam na het douchen',de:'Pflege deinen Körper nach dem Duschen'}}]};
    if(target==='face')
      return{main:'Black Soap Face Wash',second:null,alt:null,
             routine:[{name:'Still 21 Face Cream',tip:{en:'Hydrate your face afterwards',nl:'Hydrateer daarna je gezicht',de:'Feuchtigkeitspflege danach für dein Gesicht'}},
                      {name:'Drops of Nature Argan Oil',tip:{en:'Apply as the last step after your cream',nl:'Breng aan als laatste stap na je crème',de:'Als letzten Schritt nach deiner Creme auftragen'}}]};
    if(target==='body'&&shower==='clean')
      return{main:'Black Soap Body Wash',second:null,alt:null,
             routine:[{name:'Black Soap Face Wash',tip:{en:'Cleanse your face too',nl:'Reinig ook je gezicht',de:'Reinige auch dein Gesicht'}},
                      {name:'Still 21 Face Cream',tip:{en:'Hydrate your face afterwards',nl:'Hydrateer daarna je gezicht',de:'Feuchtigkeitspflege danach für dein Gesicht'}},
                      {name:'Classic Body Butter',tip:{en:'Nourish your body after showering',nl:'Verzorg je lichaam na het douchen',de:'Pflege deinen Körper nach dem Duschen'}}]};
    if(target==='body'&&shower==='oilshower'&&scent==='fruity')
      return{main:'Coco Paradise Shower Oil',second:null,alt:null,
             routine:[{name:'Coco Paradise Body Lotion',tip:{en:'Apply after showering',nl:'Breng aan na het douchen',de:'Nach dem Duschen auftragen'}},
                      {name:'Coco Paradise Body Oil',tip:{en:'Finishing touch for a beautiful glow',nl:'De finishing touch voor een mooie glow',de:'Das i-Tüpfelchen für einen schönen Glow'}},
                      {name:'Coco Paradise Body Butter',tip:{en:'Extra nourishment for dry spots',nl:'Extra voeding voor droge plekken',de:'Extra Pflege für trockene Stellen'}}]};
    if(target==='body'&&shower==='oilshower'&&scent==='sweet')
      return{main:'Aloha Shower Oil',second:null,alt:null,
             routine:[{name:'Aloha Body Lotion',tip:{en:'Apply after showering',nl:'Breng aan na het douchen',de:'Nach dem Duschen auftragen'}},
                      {name:'Aloha Body Oil',tip:{en:'Finishing touch for a beautiful glow',nl:'De finishing touch voor een mooie glow',de:'Das i-Tüpfelchen für einen schönen Glow'}}]};
  }

  if(cat==='body'){
    if(skin==='sensitive'&&scent==='kokos')
      return{main:'Coco-Loco Body Butter',second:null,alt:null,routine:[]};
    if(skin==='sensitive'&&scent==='cacao')
      return{main:'Plain Jane Body Butter',second:null,alt:null,routine:[]};
    if(tex==='rich'&&scent==='fruity')
      return{main:'Coco Paradise Body Butter',second:'Classic Body Butter',alt:'Coco Paradise Body Lotion',routine:[]};
    if(tex==='rich'&&scent==='sweet')
      return{main:'Cotton Candy Body Butter',second:'Lemon Pie Icecream Body Butter',alt:'Mangonuts Body Lotion',routine:[]};
    if(tex==='rich'&&scent==='neutral')
      return{main:'Plain Jane Body Butter',second:'Coco-Loco Body Butter',alt:'Classic Body Butter',routine:[]};
    if(tex==='light'&&scent==='fruity')
      return{main:'Coco Paradise Body Lotion',second:'Aloha Body Lotion',alt:'Coco Paradise Body Butter',
             routine:[{name:'Coco Paradise Body Oil',tip:{en:'Finishing touch for a beautiful glow',nl:'De finishing touch voor een mooie glow',de:'Das i-Tüpfelchen für einen schönen Glow'}},
                      {name:'Coco Paradise Shower Oil',tip:{en:'Start your routine in the shower',nl:'Begin je routine in de douche',de:'Starte deine Routine unter der Dusche'}},
                      {name:'Coco Paradise Body Butter',tip:{en:'Extra nourishment for dry spots',nl:'Extra voeding voor droge plekken',de:'Extra Pflege für trockene Stellen'}}]};
    if(tex==='light'&&scent==='sweet')
      return{main:'Mangonuts Body Lotion',second:'Aloha Body Lotion',alt:'Aloha Body Oil',routine:[]};
    if(tex==='oil'&&scent==='fruity')
      return{main:'Coco Paradise Body Oil',second:'Aloha Body Oil',alt:'Coco Paradise Body Lotion',
             routine:[{name:'Coco Paradise Body Lotion',tip:{en:'Combine with lotion for extra hydration',nl:'Combineer met lotion voor extra hydratatie',de:'Kombiniere es mit Lotion für extra Feuchtigkeit'}},
                      {name:'Coco Paradise Shower Oil',tip:{en:'Start your routine in the shower',nl:'Begin je routine in de douche',de:'Starte deine Routine unter der Dusche'}},
                      {name:'Coco Paradise Body Butter',tip:{en:'Extra nourishment for dry spots',nl:'Extra voeding voor droge plekken',de:'Extra Pflege für trockene Stellen'}}]};
    if(tex==='oil'&&scent==='sweet')
      return{main:'Aloha Body Oil',second:'Coco Paradise Body Oil',alt:'Aloha Body Lotion',
             routine:[{name:'Aloha Body Lotion',tip:{en:'Combine with lotion for extra hydration',nl:'Combineer met lotion voor extra hydratatie',de:'Kombiniere es mit Lotion für extra Feuchtigkeit'}},
                      {name:'Aloha Shower Oil',tip:{en:'Start your routine in the shower',nl:'Begin je routine in de douche',de:'Starte deine Routine unter der Dusche'}}]};
  }

  return{main:'Personal advice',second:null,alt:null,routine:[]};
}

var nqA={cat:null,skin:null,tex:null,target:null,shower:null,scent:null};
var nqStep=0;

function nqTotalSteps(){
  if(nqA.cat==='shower'&&nqA.target==='body') return 5;
  if(nqA.cat==='body'&&nqA.skin==='sensitive') return 3;
  return 4;
}

function nqInit(){
  var t=NQ_T[NQ_LANG];
  document.getElementById('nq-eyebrow').textContent=t.eyebrow;
  document.getElementById('nq-title').textContent=t.title;
  document.getElementById('nq-sub').textContent=t.sub;
  document.getElementById('nq-btn-retake').textContent=t.retake;
  document.getElementById('nq-routine-btn-label').textContent=t.routineBtn;
  ['back-1','back-2','back-3','back-4'].forEach(function(id){var el=document.getElementById('nq-'+id);if(el)el.textContent=t.back;});
  ['next-0','next-1','next-2','next-3','next-4'].forEach(function(id){var el=document.getElementById('nq-'+id);if(el)el.textContent=t.next;});
  document.getElementById('nq-s0-q').textContent=t.s0q;
  nqBuildOpts('nq-s0-opts',t.cats,0,'cat');
  nqUpdateStepLabel('nq-s0-label',1,4);
  nqUpdateProgress();
}

function nqBuildOpts(containerId,opts,step,key){
  var c=document.getElementById(containerId);
  c.innerHTML='';
  opts.forEach(function(o){
    var btn=document.createElement('button');
    btn.className='nq-opt';
    btn.innerHTML='<div class="nq-opt-text"><div class="nq-opt-title">'+o.title+'</div><div class="nq-opt-sub">'+o.sub+'</div>'+(o.hint?'<div class="nq-opt-hint">\u2192 '+o.hint+'</div>':'')+'</div>';
    btn.onclick=function(){nqPick(btn,step,key,o.val);};
    c.appendChild(btn);
  });
}

function nqPick(btn,step,key,val){
  btn.closest('.nq-options').querySelectorAll('.nq-opt').forEach(function(b){b.classList.remove('nq-selected');});
  btn.classList.add('nq-selected');
  nqA[key]=val;
  var nb=document.getElementById('nq-next-'+step);
  if(nb)nb.classList.add('nq-enabled');
}

function nqShowResult(){
  nqRenderResult(nqGetResult(nqA));
  nqGoToStep('result');
}

function nqNext(step){
  var nb=document.getElementById('nq-next-'+step);
  if(nb&&!nb.classList.contains('nq-enabled'))return;
  var t=NQ_T[NQ_LANG];

  if(step===0){
    document.getElementById('nq-s1-q').textContent=t.s1q;
    nqBuildOpts('nq-s1-opts',t.skins,1,'skin');
    document.getElementById('nq-next-1').classList.remove('nq-enabled');
    nqA.skin=null;
    nqUpdateStepLabel('nq-s1-label',2,4);
    nqGoToStep(1);return;
  }

  if(step===1){
    if(nqA.skin==='sensitive'&&nqA.cat==='shower'){nqShowResult();return;}
    if(nqA.skin==='sensitive'&&nqA.cat==='body'){
      document.getElementById('nq-s2-q').textContent=t.s3q_sensitive;
      nqBuildOpts('nq-s2-opts',t.scents_sensitive,2,'scent');
      document.getElementById('nq-next-2').textContent=t.viewResult;
      document.getElementById('nq-next-2').classList.remove('nq-enabled');
      nqA.scent=null;
      nqUpdateStepLabel('nq-s2-label',3,3);
      nqGoToStep(2);return;
    }
    var q2,opts2,key2;
    if(nqA.cat==='body')  {q2=t.s2q_body;   opts2=t.textures_body;  key2='tex';}
    if(nqA.cat==='shower'){q2=t.s2q_shower; opts2=t.shower_target;  key2='target';}
    if(nqA.cat==='face')  {q2=t.s2q_face;   opts2=t.face_types;     key2='tex';}
    document.getElementById('nq-s2-q').textContent=q2;
    nqBuildOpts('nq-s2-opts',opts2,2,key2);
    document.getElementById('nq-next-2').textContent=t.next;
    document.getElementById('nq-next-2').classList.remove('nq-enabled');
    nqA.tex=null;nqA.target=null;
    nqUpdateStepLabel('nq-s2-label',3,4);
    nqGoToStep(2);return;
  }

  if(step===2){
    if(nqA.cat==='body'&&nqA.skin==='sensitive'){nqShowResult();return;}
    if(nqA.cat==='face'&&nqA.tex==='oilface'){nqShowResult();return;}
    if(nqA.cat==='shower'&&nqA.target==='face'){nqShowResult();return;}
    if(nqA.cat==='shower'&&nqA.target==='body'){
      document.getElementById('nq-s3-q').textContent=t.s3q_shower_body;
      nqBuildOpts('nq-s3-opts',t.textures_shower,3,'shower');
      document.getElementById('nq-next-3').textContent=t.next;
      document.getElementById('nq-next-3').classList.remove('nq-enabled');
      nqA.shower=null;
      nqUpdateStepLabel('nq-s3-label',4,5);
      nqGoToStep(3);return;
    }
    if(nqA.cat==='body'){
      document.getElementById('nq-s3-q').textContent=t.s3q_body;
      var scentsToShow=nqA.tex==='rich'?t.scents_body:t.scents_body_no_neutral;
      nqBuildOpts('nq-s3-opts',scentsToShow,3,'scent');
      document.getElementById('nq-next-3').textContent=t.viewResult;
      document.getElementById('nq-next-3').classList.remove('nq-enabled');
      nqA.scent=null;
      nqUpdateStepLabel('nq-s3-label',4,4);
      nqGoToStep(3);return;
    }
    if(nqA.cat==='face'&&nqA.tex==='creme'){
      document.getElementById('nq-s3-q').textContent=t.s3q_creme;
      nqBuildOpts('nq-s3-opts',t.creme_skins,3,'skin');
      document.getElementById('nq-next-3').textContent=t.viewResult;
      document.getElementById('nq-next-3').classList.remove('nq-enabled');
      nqUpdateStepLabel('nq-s3-label',4,4);
      nqGoToStep(3);return;
    }
  }

  if(step===3){
    if(nqA.cat==='shower'&&nqA.target==='body'){
      if(nqA.shower==='clean'){nqShowResult();return;}
      document.getElementById('nq-s4-q').textContent=t.s4q_shower;
      nqBuildOpts('nq-s4-opts',t.scents_shower,4,'scent');
      document.getElementById('nq-next-4').textContent=t.viewResult;
      document.getElementById('nq-next-4').classList.remove('nq-enabled');
      nqA.scent=null;
      nqUpdateStepLabel('nq-s4-label',5,5);
      nqGoToStep(4);return;
    }
    nqShowResult();return;
  }

  if(step===4){nqShowResult();return;}
}

function nqPrev(step){nqGoToStep(step-1);}

function nqGoToStep(step){
  document.querySelectorAll('.nq-step').forEach(function(s){s.classList.remove('active');});
  var id=step==='result'?'nq-step-result':'nq-step-'+step;
  document.getElementById(id).classList.add('active');
  if(step==='result'){nqStep=99;document.getElementById('nq-progress').style.width='100%';}
  else{nqStep=step;nqUpdateProgress();}
  window.scrollTo({top:0,behavior:'smooth'});
}

function nqUpdateProgress(){
  var total=nqTotalSteps();
  var pct=Math.round((nqStep/total)*100);
  if(pct<5)pct=5;
  document.getElementById('nq-progress').style.width=pct+'%';
}

function nqUpdateStepLabel(id,stepNum,total){
  var el=document.getElementById(id);
  if(el)el.textContent=NQ_T[NQ_LANG].stepOf(stepNum,total||4);
}

function nqRenderResult(res){
  var t=NQ_T[NQ_LANG];
  var card=document.getElementById('nq-result-card');
  var secondHtml=res.second
    ?'<div class="nq-second-block">'
      +'<p class="nq-second-label">'+t.secondPick+'</p>'
      +'<p class="nq-second-name"><a href="'+nqUrl(res.second)+'">'+res.second+'</a></p>'
      +'<a class="nq-btn-shop-secondary" href="'+nqUrl(res.second)+'">'+t.viewProduct+'</a>'
      +'</div>'
    :'';
  var altHtml=res.alt
    ?'<div class="nq-alt-block">'
      +'<p class="nq-alt-label">'+t.altLabel+'</p>'
      +'<p class="nq-alt-name"><a href="'+nqUrl(res.alt)+'">'+res.alt+'</a></p>'
      +'</div>'
    :'';
  card.innerHTML=
    '<div class="nq-result-header">'
      +'<p class="nq-result-label">'+t.recommendation+'</p>'
      +'<h2 class="nq-result-name">'+res.main+'</h2>'
    +'</div>'
    +'<div class="nq-result-body">'
      +'<a class="nq-btn-shop" href="'+nqUrl(res.main)+'">'+t.viewProduct+'</a>'
      +secondHtml
      +altHtml
    +'</div>';
  var rw=document.getElementById('nq-routine-wrap');
  var rc=document.getElementById('nq-routine-content');
  if(res.routine&&res.routine.length>0){
    rc.innerHTML=res.routine.map(function(p,i){
      var tip=typeof p.tip==='object'?p.tip[NQ_LANG]||p.tip.en:p.tip;
      return '<div class="nq-routine-item">'
        +'<div class="nq-routine-step">'+(i+1)+'</div>'
        +'<div><a class="nq-routine-name" href="'+nqUrl(p.name)+'">'+p.name+'</a>'
        +'<p class="nq-routine-tip">'+tip+'</p></div>'
        +'</div>';
    }).join('');
    rw.style.display='block';
  }else{rw.style.display='none';}
}

function nqToggleRoutine(){
  var t=NQ_T[NQ_LANG];
  var c=document.getElementById('nq-routine-content');
  var ch=document.getElementById('nq-routine-chevron');
  var bl=document.getElementById('nq-routine-btn-label');
  var isOpen=c.classList.toggle('nq-open');
  ch.classList.toggle('nq-open',isOpen);
  bl.textContent=isOpen?t.routineClose:t.routineBtn;
}

function nqRetake(){
  nqA={cat:null,skin:null,tex:null,target:null,shower:null,scent:null};
  NQ_LANG='en';
  nqStep=0;
  document.querySelectorAll('.nq-lang-btn').forEach(function(b){b.classList.remove('active');});
  document.querySelector('.nq-lang-btn').classList.add('active');
  document.querySelectorAll('.nq-step').forEach(function(s){s.classList.remove('active');});
  document.querySelectorAll('.nq-opt').forEach(function(b){b.classList.remove('nq-selected');});
  document.querySelectorAll('.nq-btn-next').forEach(function(b){b.classList.remove('nq-enabled');});
  document.getElementById('nq-routine-content').classList.remove('nq-open');
  document.getElementById('nq-routine-chevron').classList.remove('nq-open');
  document.getElementById('nq-step-0').classList.add('active');
  nqInit();
  nqUpdateProgress();
}

if(document.readyState==='complete'){
  nqInit();
}else{
  window.addEventListener('load',function(){nqInit();});
}